import React, { createContext, useState, useEffect } from "react";

export const LanguageContext = createContext({
  isLang: "FR",
  changeLang: () => {},
});

export const LanguageProvider = ({ children }) => {
  const [isLang, setIsLang] = useState("FR"); 

  useEffect(() => {
    const params = new URLSearchParams(window.location.search);
    const urlLang = params.get("lang");

    if (urlLang) {
      const lang = urlLang.toUpperCase();
      setIsLang(lang);
      localStorage.setItem("lang", lang);
      return;
    }

    const saved = localStorage.getItem("lang");
    if (saved) setIsLang(saved);
  }, []);

  useEffect(() => {
    document.documentElement.lang = isLang.toLowerCase();
    document.documentElement.dir = isLang === "AR" ? "rtl" : "ltr";
  }, [isLang]);

  const updateURL = (lang) => {
    window.history.replaceState(null, "", `?lang=${lang.toLowerCase()}`);
  };

  const changeLang = (lang) => {
    setIsLang(lang);
    localStorage.setItem("lang", lang);
    updateURL(lang);
  };

  return (
    <LanguageContext.Provider value={{ isLang, changeLang }}>
      {children}
    </LanguageContext.Provider>
  );
};
